import { customNoAuthAxios } from "../../utils/customNoAuthAxios";
import useSWRInfinite from "swr/infinite";


export const useSwrInfiniteNoAuth = <T = any>(getKey:(pageIndex: number, previousPageData: number[]) => string | null) => {
  const fetcher = (url: string) => customNoAuthAxios.get(url).then(res => res.data);
  const swrResponse = useSWRInfinite<T>(getKey, fetcher);
  return { ...swrResponse };
};